import block from './block.json';

export const sectionMonthCalendarThemeAttributes = {
	padding: {
		top: [45, 65],
		bottom: [40, 70],
	},
	header: {
		top: [114, 132], // MainNav height
	},
	month: {
		color: '@tokens.variants.default.titleColor',
		typography: '@tokens.typographies.heading-2',
		textAlignment: 'center',
	},
};

export const SectionMonthCalendarThemeControls: ThemeControlsType = {
	// What's displayed
	title: block.title,

	// Unique string/id of the block (= the key used in theme.json)
	slug: block.slug,

	// styling attributes available for this block
	// ...the same way we define attributes for a gutenberg block
	attributes: sectionMonthCalendarThemeAttributes,

	// this renders in the Customizer panel
	// ...the same way "<InspectorControls />" renders in the gutenberg panel
	edit: () => null,
};
